const Links = {
	DASHBOARD: '/',
	LOGIN: '/login',
	SIGNUP: '/signup',
	VEHICLE_AD: '/vehicle-ad',
	UPCOMING_CARS: '/upcoming-cars',
	USER: '/user',
	VEHICLE: '/vehicle',
	META_DATA: '/meta-data',
	UTIL: '/util',
	BANK_FORMS: '/bank-forms',
	SLIDER_IMAGE: '/slider-image',
	BANNER: '/banner',
	SUGGESTION: '/suggestion',
	PACKAGES: '/packages',
	SERVICES: '/services',
	ANALYTICS: '/analytics',
	ORDERS: '/orders',
	INSPECTION_ORDERS: '/inspection-orders',
	LEADS: '/leads',
	CALENDER: '/calender',
	TAGS: '/tags',
	USERLEVELS: '/user-levels',
};

export default Links;
